export default __webpack_public_path__ + "static/media/level-4.59a88dc3.png";